import React from "react";

import { MdError } from "react-icons/md";

import Icon from "@/components/icons/icon";

export default function AlertIconViewer(props) {
  return (
    <Icon {...props}>
      <MdError />
    </Icon>
  )
}